import IconButton from 'src/common/ui-kit/IconButton'
import {
  ConnectButton,
  ConnectButtonProps,
  useActiveAccount,
} from 'thirdweb/react'
import ChildWithBadge from 'src/common/ui-kit/ChildWithBadge'
import { useNavigate } from 'react-router-dom'
import { useProfile } from 'src/common/api-clients/thirdweb/useProfile'
import { walletRoutes } from 'src/pages/WalletPage/wallet-routes'
import Icon from 'src/common/ui-kit/Icon/Icon'

const ConnectWalletMobile: React.FC<ConnectButtonProps> = ({ ...props }) => {
  const account = useActiveAccount()
  const navigate = useNavigate()
  const { data: profile } = useProfile()

  const handleProfileClick = () => {
    navigate(walletRoutes.path)
  }

  return account ? (
    <ChildWithBadge
      onClick={handleProfileClick}
      badgeIcon={
        <Icon
          name='wallet'
          className='bg-primary  text-primary-contrast rounded-full p-1'
        />
      }
      badgeSize={20}
    >
      <IconButton>
        <img className='w-8 h-auto rounded-full' src={profile.avatar} />
      </IconButton>
    </ChildWithBadge>
  ) : (
    <ConnectButton
      connectButton={{
        style: { height: 40, minWidth: 'unset' },
      }}
      {...props}
    />
  )
}

export default ConnectWalletMobile
